export default "__VITE_ASSET__4841ee40__"